import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import { numeralFormat } from 'src/utils/misc';
import styled from 'styled-components';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { CashPlaceholder } from '../comps';

const Wrap = styled(BaseCard)`
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    height: 100%;

    &__item {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
`;

interface CurrentSecurityProgrammeProps {
  value: DashboardQuery['dashboard']['securityProgram'];
  state: AssessmentState;
}

export const CurrentSecurityProgram: React.FC<CurrentSecurityProgrammeProps> = ({ value, state }) => {
  return (
    <Wrap>
      <span className="c-title">Current Security Programme</span>

      <div className="grid">
        <div className="grid__item">
          <Poppins px={12} weight={500}>
            RISK REDUCTION
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>between unmodified and live risk</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ||
          state === 'SCENARIOS_NO_CONTROLS' ||
          state === 'SCENARIOS_CONTROLS_NO_MODIFIERS' ? (
            <CashPlaceholder state={state} />
          ) : (
            <Poppins weight={600} color="gp1" px={26} className="value">
              {numeralFormat(value?.riskReduction)}
            </Poppins>
          )}
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            COST
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>of the existing control required to achieve this reduction</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ||
          state === 'SCENARIOS_NO_CONTROLS' ||
          state === 'SCENARIOS_CONTROLS_NO_MODIFIERS' ? (
            <CashPlaceholder state={state} />
          ) : (
            <Poppins weight={600} color="gp1" px={26} className="value">
              {numeralFormat(value?.cost)}
            </Poppins>
          )}
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            SAVINGS
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>as a result of the security program</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ||
          state === 'SCENARIOS_NO_CONTROLS' ||
          state === 'SCENARIOS_CONTROLS_NO_MODIFIERS' ? (
            <CashPlaceholder state={state} />
          ) : (
            <Poppins weight={600} color="gp1" px={26} className="value">
              {numeralFormat(value?.savings)}
            </Poppins>
          )}
        </div>
      </div>
    </Wrap>
  );
};
